import { useEffect } from "react";
import {useRowSelectionContext} from "@portfolio/context/RowSelectionContextProvider";

function useSearchEscapeHandler({
                                    setSearchQuery,
                                    setShowSearchPopup,
                                    setInputValue,
                                    setScrollToSymbol
                                }) {
    const { inputRef, outerListRef } = useRowSelectionContext();

    useEffect(() => {
        const handleKeyDown = (e) => {
            // ✅ Ctrl+S opens search
            if (e.altKey && e.key.toLowerCase() === 's') {
                e.preventDefault();
                setShowSearchPopup(true);
                setTimeout(() => inputRef?.current?.focus(), 0);
                return;
            }

            // ✅ Escape closes search and scrolls back to matched symbol
            if (e.key !== "Escape") return;

            const isSearchFocused =
                inputRef?.current?.contains(document.activeElement) ||
                document.activeElement?.tagName === "INPUT";

            if (isSearchFocused) {
                setSearchQuery("");
                setShowSearchPopup(false);
                setInputValue("");

                const matched = window.__lastMatchedSymbol;
                window.__lastMatchedSymbol = null;

                setTimeout(() => {
                    outerListRef?.current?.focus();
                    if (matched) setScrollToSymbol(matched);
                }, 400);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [inputRef, outerListRef, setSearchQuery, setShowSearchPopup, setInputValue, setScrollToSymbol]);
}

export default useSearchEscapeHandler;
